import { compose } from 'redux';
import { connect } from 'react-redux';
import onlyIf from '../hocs/onlyIf';
import EmbedlySizer from '../components/EmbedlySizer';
import * as device from '../selectors/device';
import { setContainerHeight } from '../actionCreators';
import { shouldSizeEmbedlyContainer } from '../selectors/embedly';
function mapStateToProps(state) {
    var shouldRender = shouldSizeEmbedlyContainer(state);
    if (!shouldRender) {
        return {};
    }
    var dimensions;
    try {
        // If the project hasn't loaded yet we don't know the device
        dimensions = device.getDimensions(state);
    }
    catch (e) {
        return {};
    }
    return {
        naturalDeviceWidth: dimensions.width,
        naturalDeviceHeight: dimensions.height,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        setContainerHeight: function (height) {
            dispatch(setContainerHeight(height));
        },
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps), onlyIf(function (props) { return props.naturalDeviceWidth; }))(EmbedlySizer);
